<template>
  <v-container
    v-if="document"
    style="max-width: 100% !important; height:100%"
  >
    <v-card>
      <v-app-bar fixed dense color="grey lighten-5">
        <v-btn small tile @click="closeExternalDocument" style="margin-right: 15px">
          <v-icon>mdi-close</v-icon>Close
        </v-btn>
        <v-btn
          v-if="
            !$loginState.readOnly &&
            (docTypes.length === 1 || document.doc_status === 'DELETED')
          "
          small
          tile
          @click="copyDocument"
          style="margin-right: 15px"
        >
          <v-icon>mdi-content-copy</v-icon>Copy
        </v-btn>
        <v-menu
          v-if="
            !$loginState.readOnly &&
            docTypes.length > 1 &&
            document.doc_status !== 'DELETED'
          "
          v-model="copymenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!$loginState.readOnly"
              small
              tile
              style="margin-right: 15px"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-content-copy</v-icon>Copy/Link
            </v-btn>
          </template>

          <v-card>
            <v-list dense>
              <v-list-item dense>
                <v-list-item-action>
                  <v-btn dense text @click="linkDocumentAction(null, 'copy')">
                    <span class="ml-1">Copy {{ linkDef.tmpl_name }}</span>
                  </v-btn>
                </v-list-item-action>
                <v-spacer></v-spacer>
                <v-list-item-action>
                  <v-btn dense text @click="copymenu = false">Cancel</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list dense>
              <v-subheader
                >{{
                  docTypes.filter((x) => x.canCreate || x.docs.length > 0)
                    .length === 0
                    ? "No "
                    : ""
                }}
                Linked Documents</v-subheader
              >
              <v-list-item
                v-for="(dt, dti) in docTypes.filter(
                  (x) => x.canCreate || x.docs.length > 0
                )"
                :key="'dt_' + dti"
                dense
              >
                <v-list-item-avatar>
                  <PartTypeIcon :partType="dt.docAbbrev"></PartTypeIcon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div>
                    <v-btn
                      v-if="dt.docs.length === 1"
                      dense
                      text
                      @click="linkDocumentAction(dt.docs[0], 'view')"
                      >{{ dt.tmpl_name }} {{ dt.docs[0].reference }}</v-btn
                    >
                    <v-menu offset-y v-if="dt.docs.length > 1">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dense text v-bind="attrs" v-on="on">
                          {{ dt.tmpl_name }}s
                          <v-icon>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          dense
                          v-for="(d, di) in dt.docs"
                          :key="'tv' + dti + '_' + di"
                          @click="linkDocumentAction(d, 'view')"
                        >
                          <v-list-item-title>{{
                            d.reference
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      v-if="dt.canCreate"
                      dense
                      text
                      @click="linkDocumentAction(dt, 'link')"
                      >Create
                      {{
                        !dt.docs.length ? "Linked " + dt.tmpl_name : ""
                      }}</v-btn
                    >
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu
          v-model="exportMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              tile
              style="margin-right: 15px"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-file-download-outline</v-icon>Export
            </v-btn>
          </template>

          <v-card>
            <v-list dense>
              <v-list-item dense>
                <v-list-item-content>
                  <v-list-item-title>Export Options</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn dense text @click="exportMenu = false">Cancel</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
              <div v-if="!this.$loginState.readOnly">
                <v-list-item
                  v-for="(sec, si) in html_export_sections"
                  :key="'dt' + si"
                  dense
                >
                  <v-row>
                    <v-col cols="1">
                      <v-icon>{{
                        "mdi-numeric-" + (si + 1) + "-box-multiple-outline"
                      }}</v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-btn dense text @click="docToClipboard(sec)">{{
                        sec.replace(/ .*/, "") +
                        (sec.replace(/ .*/, "") === "Section"
                          ? " " + (si + 1)
                          : "") +
                        " to Clipboard"
                      }}</v-btn>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item key="dt09" dense v-if="usesTaleoFeed">
                  <v-row>
                    <v-col cols="1">
                      <v-icon>mdi-transfer-right</v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-btn
                        v-if="this.$loginState.user.client === 'Akamai'"
                        dense
                        text
                        @click="sendToTaleo()"
                        >Export to ACE</v-btn
                      >
                      <v-btn v-else dense text @click="sendToTaleo()"
                        >Export to ATS</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-list-item>
              </div>
              <v-list-item key="dt10" dense>
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-btn dense text @click="generatePDF()"
                      >Download PDF</v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item key="dt11" dense>
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-file-word</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-btn dense text @click="generateRTF()"
                      >Download RTF</v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item key="dt14" dense>
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-file-word-box-outline</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-btn dense text @click="generateDOCX()"
                      >Download Word</v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item key="dt12" dense>
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-file-word-box</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-btn dense text @click="generateDOCX(true)"
                      >Download Word (+Notes)</v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item
                key="dt13"
                dense
                v-if="
                  this.usesInterviewTemplate ||
                  this.$loginState.user.client === 'Scottish Parliament' ||
                  this.$loginState.user.client === 'Baker Hughes'
                "
              >
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-view-list-outline</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-btn dense text @click="generateInterviewTemplate()"
                      >Export Interview Template</v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item
                key="dt15"
                dense
                v-if="
                  (this.$loginState.user.client === 'Akamai' ||
                    this.$loginState.user.client === 'Elsevier'||
                    this.$loginState.user.client === 'Demo') &&
                  this.document.state.canEditDocParts
                "
              >
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-account-reactivate</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <v-btn dense text @click="generateIntakeFlow()">
                      <span v-if="this.$loginState.user.client === 'Akamai'"
                        >Export Launch Template</span
                      >
                      <span v-else>Export Intake Flow</span></v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <div
          v-if="docTypes.length > 1"
          class="headerCell"
          style="padding-left: 60px; padding-top: 13px !important"
        >
          <PartTypeIcon
            :partType="document.doc_type_abbrev"
            :file_info="document.file_data"
            size="medium"
          ></PartTypeIcon>
          <span style="top: 0px; left: 4px; position: relative"
            >ID: {{ documentId }}</span
          >
        </div>
        <div
          v-else
          class="headerCell"
          style="padding-left: 60px; padding-top: 13px !important"
        >
          <span>ID: {{ documentId }}</span>
        </div>
        <div
          class="headerCell"
          style="
            padding-left: 60px;
            padding-top: 13px !important;
            cursor: pointer;
          "
          @click="openHeader"
        >
          <span style="font-size: 18px; padding-top: 6px">{{
            document.doc_name
          }}</span>
        </div>
        <div
          class="headerCell"
          style="
            padding-left: 60px;
            padding-top: 13px !important;
            cursor: pointer;
          "
        >
          <v-btn color="success" class="white--text"  @click="downloadFile()" target="_blank">
            <v-icon>
                mdi-cloud-download
            </v-icon>
          </v-btn> 
        </div>       
        
        <v-spacer></v-spacer>
        <div class="headerCellSmall" @click="openHeader">
          <div
            style="margin-top: 7px; cursor: pointer"
            v-if="hierarchyTypes.find((h) => h.ht_id === 3)"
          >
            <span>{{ hierarchyTypes.find((h) => h.ht_id === 3).label }}:</span>
            <span
              v-if="document.hierarchies.find((h) => h.ht_id === 3)"
              style="padding-left: 5px"
              >{{
                document.hierarchies.find((h) => h.ht_id === 3).hierarchy1
              }}</span
            >
          </div>
          <div v-if="hierarchyTypes.find((h) => h.ht_id === 1)">
            <span>{{ hierarchyTypes.find((h) => h.ht_id === 1).label }}:</span>
            <span
              v-if="document.hierarchies.find((h) => h.ht_id === 1)"
              style="padding-left: 5px"
            >
              {{
                this.$loginState.user.client !== "Baker Hughes"
                  ? ""
                  : document.hierarchies.find((h) => h.ht_id === 1).hierarchy2 +
                    " / "
              }}
              {{ document.hierarchies.find((h) => h.ht_id === 1).hierarchy1 }}
            </span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="headerCell" style="padding-left: 60px; cursor: pointer">
          <v-chip
            dense
            class="mx-2 status-chip"
            :color="
              document.doc_status === 'APPROVED'
                ? 'green'
                : document.doc_status === 'DRAFT'
                ? 'red'
                : 'orange'
            "
            label
            outlined
            @click="openHeader"
            >{{ document.doc_status_text }}</v-chip
          >
        </div>
        <!-- <div class="headerCell" style="padding-left: 60px; cursor: pointer">
          <v-chip
            dense
            class="mx-2 status-chip"
            label
            outlined
            @click="openCheckStatus"
            >Checks</v-chip
          >
        </div> -->
      </v-app-bar>
    </v-card>
    <input type="text" id="htmlexport" style="height: 5px; width: 5px" />
    <v-row
      style="max-height: 60px; margin-top: -18px; color: rgba(0, 0, 0, 0.6)"
    >
      <v-col cols="2"></v-col>
      <v-col cols="9">
        <v-row></v-row>
      </v-col>
    </v-row>
    <v-row
      style="max-height: 60px; margin-top: -18px; color: rgba(0, 0, 0, 0.6)"
    >
      <v-col cols="2"></v-col>
      <v-col cols="9">
        <v-row></v-row>
      </v-col>
    </v-row>
    <v-row dense id="doccontainer" style="height:90%">
      <v-col cols="9" style="height:100%">
        <!-- class="mx-auto no-print-border printFullWidth"
          style="
            max-width: 1024px;
            border-radius: 12px;
            margin-top: 12px;
            margin-left: 160px;
          " -->
        <v-card
          class="no-print-border printFullWidth"
          style="
            max-width: 70%;
            max-width: 90%;
            border-radius: 12px;
            margin-top: 12px;
            margin-left: 15%;
            height:100%
          "
        >
          <v-card-text class="pa-1" style="height:100%">
            <v-row style="height:100%">
                <v-col cols="12" align="center" style="height:100%">
                    <iframe v-if="!showInlinePDF" :src="inlineView" width='100%' height='100%' frameborder='0'></iframe>
                    <!-- <pdf  style="overflow-y:scroll; max-height: 100%" v-if="showInlinePDF" :src="inlineView"></pdf> -->
                </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="3"
        v-if="document.doc_status !== 'APPROVED' || document.state.canEditDocParts"
      >
        <v-card
          style="top: 60px; right: 30px; max-width: 24%; position: fixed"
          class="scoreCard"
          v-if="checkSummary && checkSummary.categories.length"
        >
          <v-card-title class="scoreTitle"
            >Document Inclusion & Quality <v-spacer></v-spacer
            ><v-btn
              icon
              dense
              @click="allCheckSummaryPanels"
              v-if="checkSummaryPanels.length < checkSummary.categories.length"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
            <v-btn
              icon
              dense
              @click="closeCheckSummaryPanels"
              v-if="
                checkSummaryPanels.length === checkSummary.categories.length
              "
            >
              <v-icon>mdi-chevron-double-up</v-icon>
            </v-btn></v-card-title
          >
          <v-card-text dense style="padding: 0">
            <v-expansion-panels accordion multiple v-model="checkSummaryPanels">
              <v-expansion-panel
                class="sectionScore"
                v-for="(i, ii) in checkSummary.categories"
                :key="'i' + ii"
              >
                <v-expansion-panel-header>
                  <span class="sectionText"
                    >{{ i.category.trim() + " " }}
                    <v-badge
                      :content="i.errorCount"
                      color="red"
                      inline
                      overlap
                      v-if="i.errorCount"
                    >
                    </v-badge
                    ><v-badge
                      :content="i.warningCount"
                      color="amber"
                      inline
                      overlap
                      v-if="i.warningCount"
                    >
                    </v-badge
                  ></span>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="checkSummaryView === 1">
                  <v-row
                    dense
                    v-for="(c, ci) in i.titles"
                    :key="'i' + ii + 'ci' + ci"
                  >
                    <v-col>
                      <v-row dense>
                        <v-col cols="1"></v-col>
                        <v-col cols="11"
                          ><span style="font-size: 13px">{{
                            c.title
                          }}</span></v-col
                        >
                        <!-- <v-col cols="9">
						</v-col> -->
                      </v-row>
                      <v-row
                        dense
                        v-for="(e, ei) in checkSummary.errors.filter(
                          (x) =>
                            x.category === i.category && x.title === c.title
                        )"
                        :key="'e_' + ii + '_' + ei"
                      >
                        <v-col cols="1"></v-col>
                        <v-col
                          cols="11"
                          @mouseenter="highlightSection(e)"
                          @mouseleave="unhighlightSection"
                          @click="scrollToSection(e)"
                          class="sectionItem"
                        >
                          <v-badge
                            color="red"
                            :content="e.count"
                            inline
                            overlap
                            style="color: slategray; font-size: 12px"
                          >
                            <div
                              :style="{
                                'min-width': '22px',
                                height: e.effect === 'highlight' ? '22px' : '',
                                'margin-right': '10px',
                                'background-color':
                                  e.effect === 'highlight'
                                    ? e.colour
                                    : 'transparent',
                                'border-bottom':
                                  e.effect.indexOf('dotted') >= 0
                                    ? 'dotted 3px ' + e.colour
                                    : e.effect.indexOf('solid') >= 0
                                    ? 'solid 3px ' + e.colour
                                    : '',
                              }"
                            ></div>
                            <div v-html="e.description"></div>
                          </v-badge>
                        </v-col>
                      </v-row>
                      <v-row
                        dense
                        v-for="(w, wi) in checkSummary.warnings.filter(
                          (x) =>
                            x.category === i.category && x.title === c.title
                        )"
                        :key="'w_' + ii + '_' + wi"
                      >
                        <v-col cols="1"></v-col>
                        <v-col
                          cols="11"
                          @mouseenter="highlightSection(w)"
                          @mouseleave="unhighlightSection"
                          @click="scrollToSection(w)"
                          class="sectionItem"
                        >
                          <v-badge
                            color="amber"
                            :content="w.count"
                            inline
                            overlap
                            style="color: slategray; font-size: 12px"
                          >
                            <div
                              :style="{
                                'min-width': '22px',
                                height: w.effect === 'highlight' ? '22px' : '',
                                'margin-right': '10px',
                                'background-color':
                                  w.effect === 'highlight'
                                    ? w.colour
                                    : 'transparent',
                                'border-bottom':
                                  w.effect.indexOf('dotted') >= 0
                                    ? 'dotted 3px ' + w.colour
                                    : w.effect.indexOf('solid') >= 0
                                    ? 'solid 3px ' + w.colour
                                    : '',
                              }"
                            ></div>
                            <div v-html="w.description"></div>
                          </v-badge>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
                <v-expansion-panel-content
                  v-if="checkSummaryView === 2"
                  style="margin-top: -12px"
                >
                  <v-row
                    dense
                    v-for="(t, ti) in i.titles"
                    :key="'i' + ii + 'ti' + ti"
                  >
                    <v-col cols="1">
                      <div
                        :style="{
                          'margin-top': '3px',
                          height:
                            t.effect === 'highlight' || t.effect === 'border'
                              ? '18px'
                              : '12px',
                          'background-color':
                            t.effect === 'highlight' ? t.colour : 'transparent',
                          'border-bottom':
                            t.effect.indexOf('dotted') >= 0
                              ? 'dotted 3px ' + t.colour
                              : t.effect.indexOf('solid') >= 0
                              ? 'solid 3px ' + t.colour
                              : t.effect === 'border'
                              ? 'solid 1px ' + t.colour
                              : '',
                          'border-top':
                            t.effect === 'border'
                              ? 'solid 1px ' + t.colour
                              : '',
                          'border-left':
                            t.effect === 'border'
                              ? 'solid 1px ' + t.colour
                              : '',
                          'border-right':
                            t.effect === 'border'
                              ? 'solid 1px ' + t.colour
                              : '',
                          'border-radius': t.effect === 'border' ? '4px ' : '',
                        }"
                      >
                        <v-icon v-if="t.effect.substr(0, 5) === 'icon-'">{{
                          t.effect.substr(5)
                        }}</v-icon>
                        <!-- 'border': t.effect === 'border' ? '1px solid ' + t.colour : 'inherit' -->
                      </div>
                    </v-col>
                    <v-col cols="11">
                      <span style="font-size: 13px; margin-right: 10px">{{
                        t.title
                      }}</span>
                      <span
                        v-for="(d, di) in t.issues"
                        :key="'i' + ii + 'ti' + ti + 'di' + di"
                      >
                        <v-tooltip bottom v-if="d.errorCount > 0">
                          <template v-slot:activator="{ on, attrs }"
                            ><v-btn
                              x-small
                              text
                              v-bind="attrs"
                              v-on="on"
                              @mouseenter="highlightSection(d, true)"
                              @mouseleave="unhighlightSection"
                              @click="scrollToSection(d)"
                              class="sectionItem"
                            >
                              <v-icon color="red" style="font-size: 18px"
                                >mdi-alert</v-icon
                              >
                              <span
                                v-if="d.errorCount > 1"
                                style="
                                  margin-top: -12px;
                                  margin-left: -5px;
                                  font-size: 9px;
                                  text-transform: none;
                                "
                                >x{{ d.errorCount }}</span
                              ></v-btn
                            >
                          </template>
                          <div style="max-width: 300px">
                            <span v-html="d.description"></span>
                          </div>
                        </v-tooltip>
                        <v-tooltip bottom v-if="d.warningCount > 0">
                          <template v-slot:activator="{ on, attrs }"
                            ><v-btn
                              x-small
                              text
                              v-bind="attrs"
                              v-on="on"
                              @mouseenter="highlightSection(d)"
                              @mouseleave="unhighlightSection"
                              @click="scrollToSection(d)"
                              class="sectionItem"
                            >
                              <v-icon color="grey" style="font-size: 18px"
                                >mdi-alert</v-icon
                              >
                              <span
                                v-if="d.warningCount > 1"
                                style="
                                  margin-top: -12px;
                                  margin-left: -5px;
                                  font-size: 9px;
                                  text-transform: none;
                                "
                                >x{{ d.warningCount }}</span
                              ></v-btn
                            >
                          </template>
                          <div style="max-width: 300px">
                            <span v-html="d.description"></span>
                          </div>
                        </v-tooltip>
                      </span>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
                <v-expansion-panel-content
                  v-if="checkSummaryView === 3"
                  style="margin-top: -12px"
                >
                  <v-row
                    dense
                    v-for="(t, ti) in i.titles"
                    :key="'i' + ii + 'ti' + ti"
                  >
                    <v-col cols="1">
                      <div
                        :style="{
                          'margin-top': '3px',
                          height: t.effect === 'highlight' ? '18px' : '12px',
                          'background-color':
                            t.effect === 'highlight' ? t.colour : 'transparent',
                          'border-bottom':
                            t.effect.indexOf('dotted') >= 0
                              ? 'dotted 3px ' + t.colour
                              : t.effect.indexOf('solid') >= 0
                              ? 'solid 3px ' + t.colour
                              : '',
                        }"
                      ></div>
                    </v-col>
                    <v-col cols="8">
                      <span style="font-size: 13px; margin-right: 10px">{{
                        t.title
                      }}</span>
                    </v-col>
                    <v-col cols="3">
                      <div
                        style="
                          width: 100%;
                          border: solid #f0e8e8 1px;
                          height: 19px;
                        "
                      >
                        <div
                          v-for="n in t.errorCount"
                          :key="'i' + ii + 'ti' + ti + 'n' + n"
                          :style="{
                            width: 100 / checkSummary.maxIssues - 2 + '%',
                            'background-color': 'red',
                            margin: '1%',
                            float: 'left',
                            height: '15px',
                          }"
                        ></div>
                        <div
                          v-for="n in t.warningCount"
                          :key="'i' + ii + 'ti' + ti + 'n' + n"
                          :style="{
                            width: 100 / checkSummary.maxIssues - 2 + '%',
                            'background-color': 'orange',
                            margin: '1%',
                            float: 'left',
                            height: '15px',
                          }"
                        ></div>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <TextEdit
      :open="textEdit.show"
      @saved="saveTextEdit"
      @closed="textEdit.show = false"
      @deleted="deleteTextEdit"
      :settings="textEdit"
    ></TextEdit>
    <RoleFlex
      :open="roleFlex.show"
      @closed="roleFlex.show = false"
      @workingPattern="newWorkingPattern"
      label="text"
      :documentId="roleFlex.documentId"
      :docPart="roleFlex.docPart"
    ></RoleFlex>
    <DocumentHeader
      :open="showHeaderDetail"
      :source="document"
      :checks="checkSummary"
      @saved="documentHeaderSaved"
      @closed="documentHeaderClosed"
    ></DocumentHeader>
    <v-dialog v-model="reqDialogue.show" max-width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" dense>
          <v-toolbar-title>Send Content To Taleo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn @click="postToTaleo()" :disabled="!reqDialogue.value"
            >Send</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn @click="reqDialogue.show = false">Cancel</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                label="Requisition Number"
                type="number"
                required
                v-model="reqDialogue.value"
              ></v-text-field>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="reqDialogue.USA"
                label="US Job?"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmCopyShow" max-width="700px">
      <v-card>
        <v-card-actions>
          <div class="pa-2">Copy Confirmation</div>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmCopyShow = false" color="primary"
            >Cancel</v-btn
          >
          <v-btn text @click="doCopy()">Copy Document</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col>{{ confirmCopy }}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <CheckStatus
      :source="checkSummary"
      :open="showCheckStatus"
      @closed="closeCheckStatus"
    />
    <Loading :isVisible="isLoading" />
    <div id="pdfsection" style="max-width: 900px; padding: 50px"></div>
  </v-container>
</template>

<script>

import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
import TextEdit from "@/components/cTextEditDialogue"; // @ is an alias to /src
import RoleFlex from "@/components/cRoleFlex"; // @ is an alias to /src
import DocumentHeader from "@/components/cDocumentHeader"; // @ is an alias to /src
import CheckStatus from "@/components/cDocumentCheckStatus";
import PartTypeIcon from "@/components/cPartTypeIcon"; // @ is an alias to /src
import utils from "@/common/utils.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { asBlob as html2docx } from 'html-docx-js-typescript';
import ScrollTo from "vue-scrollto";
//import pdf from 'vue-pdf-yzd';

export default {
  name: "DocumentExternal",
  components: {
    ResponseHandler,
    TextEdit,
    RoleFlex,
    DocumentHeader,
    PartTypeIcon,
    CheckStatus,
    //pdf
  },
  props: {
    item: null,
    documentId: null,
    isCopied: null,
  },
  data: function () {
    return {
      response: null,
      document: null,
      hierarchyTypes: [],
      isDirty: false,
      isLoading: false,
      isEditable: false,
      downloadLink: "",
      textEdit: {
        text: "",
        notes: "",
        label: "text",
        show: false,
        showWordCount: true,
        showNotes: true,
        title: "",
        rules: null,
        lookup: [],
        wordChecks: [],
        //closed: false
      },
      roleFlex: {
        documentId: "",
        show: false,
        docPart: {},
      },
      dragging: false,
      pdfing: false,
      showHeaderDetail: false,
      showCheckStatus: false,
      checkSummary: null,
      checkSummaryPanels: [],
      checkSummaryView: 2,
      html_export_sections: [],
      exportMenu: false,
      docTypes: [],
      linkDef: null,
      copymenu: false,
      reqDialogue: {
        show: false,
        value: null,
      },
      usesTaleoFeed: false,
      usesInterviewTemplate: false,
      usesIntakeFlow: false,
      wayBackHidden: true,
      dpScrolled: [],
      confirmCopy: "",
      confirmCopyShow: false,
      inlineView: "",
      showInlinePDF: false
    };
  },
  created() {
    this.resp = null;
    if (!this.item) {
      

      this.fetchData();
    } else {
      this.document = JSON.parse(JSON.stringify(this.item));
    }

  },
  updated() {
    if (this.item) {
      this.document = JSON.parse(JSON.stringify(this.item));
    }
  },
  watch: {
    documentId(newval) {
      if (newval) this.fetchData();
    },
  },
  methods: {
    downloadFileTest(){
//
      axios
        .get("file/downloadTest/", {responseType: 'blob'})
        .then((resp) => {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'file.docx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          alert(err);
        });
    },
    downloadFile(){
      window.open(this.document.file_data.downloadUrl,"_blank");
    },

        resolveIcon(extension){

          switch(extension){
              case "xlsx":
              case "xls":
                  return "mdi-microsoft-excel";
              case "doc":
              case "docx":
                  return "mdi-microsoft-word";
              case "txt":
              case "log":
                  return "mdi-file-document-outline";
              case "pdf":
                  return "mdi-file-pdf-box";
          }

      },
      resolveHeaderStyle(extension){

          switch(extension){
              case "xlsx":
              case "xls":
                  return "#3cc542ad";
              case "doc":
              case "docx":
                  return "#327bb5c7";
              case "txt":
              case "log":
                  return "#ff23138f";
              case "pdf":
                  return "#ff23138f";
          }

      },      
    fetchData() {
      this.isLoading = true;
      axios.get("document/getHierarchyValues").then((resp) => {
        if (resp.data.Status === "OK") {
          let dts = resp.data.Data.docTypes;
          this.statuses = resp.data.Data.statuses;
          axios
            .get("document/docswithparts/" + this.documentId)
            .then((resp) => {
              if (resp.data.Status === "OK") {
                this.hierarchyTypes = resp.data.Data.hierarchyTypes;
                this.textEdit.wordChecks = utils.initialisePartChecks(
                  resp.data.Data.documents[0].wordChecks
                );
                this.setupDocument(resp.data.Data.documents);
                this.setEditable();
                this.linkDef = dts.find(
                  (x) => x.tmpl_id === this.document.tmpl_id
                );

                dts.forEach((dt) => {
                  dt.docs = this.document.linkedDocs.filter(
                    (ld) => ld.tmpl_id === dt.tmpl_id
                  );
                  dt.canCreate =
                    this.linkDef.linked_templates &&
                    this.linkDef.linked_templates.some(
                      (x) =>
                        x.tmpl_id === dt.tmpl_id &&
                        (x.max_links === 0 || dt.docs.length < x.max_links)
                    );
                  if (dt.tmpl_name === "Interview Template")
                    this.usesInterviewTemplate = true;
                });
                this.docTypes = dts;
                this.isLoading = false;
                this.setCheckSummary();
                if (this.isCopied) {
                  this.openHeader();
                }
              }
              this.response = resp.data;
              

              //console.log(resp);
            })
            .catch((err) => {
              if (err.response && err.response.status === 401) {
                this.$emit("sessionExpired", err);
              } else {
                console.log(err);
                this.response = err.response
                  ? err.response.data
                  : { message: "Unexpected Error" };
              }
              this.isLoading = false;
            });
        }
      });
    },
    setupDocument(doc) {
      let usesTaleoFeed = false;
      this.document = doc.map((x) => {
        let n = JSON.parse(JSON.stringify(x));

        n.parttypes.forEach((pt) => {
          pt.parts.forEach((p) => {
            p.rowDirty = false;
            p.rowMessage = "";
            p.expanded = false;
			p.highlightSection = false;
			p.childParts.forEach(cp => cp.highlightSection = false);
            utils.setDocPartStatus(
              p,
              pt.tmpl_part_metadata,
              this.textEdit.wordChecks
            );
          });
          let sections = (pt.tmpl_part_metadata.html_export_section || "")
            .split("|")
            .filter((x) => x);
          if (sections) {
            if (
              sections.some(
                (x) => x.startsWith("internal") || x.startsWith("external")
              )
            )
              usesTaleoFeed = true;
            sections
              .filter(
                (x) => !x.startsWith("internal") && !x.startsWith("external") // just for taleo push
              )
              .forEach((sec) => {
                if (this.html_export_sections.indexOf(sec) < 0) {
                  this.html_export_sections.push(sec);
                }
              });
          }
        });
    if(n.doc_type == 'External File'){
      // if(n.file_data.file_extension.toLowerCase() == "pdf"){

      //   this.inlineView = n.file_data.downloadUrl;
      //   this.showInlinePDF = true;

    

      // } else{
        this.inlineView = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(n.file_data.downloadUrl) + '&embedded=true';
        this.showInlinePDF = false;
      //}
    }



        return n;
      })[0];


    

      this.usesTaleoFeed = usesTaleoFeed;
    },
    setEditable() {
      this.isEditable =
        this.document.doc_status !== "APPROVED" &&
        this.document.state.canEditDocParts;
    },
    saveEssential(row, partType) {
      this.saveRow(
        row,
        row.text,
        row.notes,
        null,
        !row.is_essential,
        row.quality,
        partType
      );
    },
    saveRow(
      row,
      newval,
      newnotes,
      newsubparts,
      is_essential,
      quality,
      partType
    ) {
      this.isLoading = true;
      if (newsubparts && newsubparts.length) {
        newval = utils.subpartsToPart(newsubparts);
      }
      const isNew = !row.doc_part_id;
      let data = {
        text: newval,
        notes: newnotes,
        is_essential: is_essential,
        quality: quality,
        doc_part_id: row.doc_part_id,
        doc_part_type: partType.type,
        tmpl_part_id: row.tmpl_part_id,
      };
      if (isNew) {
        data.sequence = row.sequence;
        data.doc_id = this.document.doc_id;
        data.system_number = this.document.system_number;
        data.parent_dp_id = row.parent_dp_id;
      }

      axios
        .post("document/savedocpart/", data)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            row.rowDirty = false;
            row.text = newval;
            row.notes = newnotes;
            row.is_essential = is_essential;
            row.quality = quality;
            utils.setDocPartStatus(
              row,
              partType.tmpl_part_metadata,
              this.textEdit.wordChecks
            );
            if (isNew) {
              row.doc_part_id = resp.data.Data[0][0].doc_part_id;
              row.dp_name =
                resp.data.Data[0][0].dp_name || resp.data.Data[0][0].tp_name;
              if (partType.parts) {
                row.childParts = [];
                row.expanded = false;
                partType.parts.push(row);
              } else {
                this.textEdit.parent.childParts.push(row);
              }
            }
            this.setCheckSummary();
          } else {
            row.rowMessage = resp.data.Message;
          }
          this.response = resp.data;
          console.log(resp);
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            row.rowMessage = err;
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    deleteRow(row, partType, parent) {
      this.isLoading = true;
      let data = {
        id: row.id,
        doc_part_id: row.doc_part_id,
        doc_part_type: partType.type,
        tmpl_part_id: row.tmpl_part_id,
      };

      axios
        .post("document/removedocpart/", data)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            row.rowDirty = false;
            let parts = parent
              ? parent.childParts
              : this.document.parttypes.find((pt) => pt.type === partType.type)
                  .parts;
            let pIndex = parts.findIndex(
              (p) => p.doc_part_id === data.doc_part_id
            );
            parts.splice(pIndex, 1);
          } else {
            row.rowMessage = resp.data.Message;
          }
          this.response = resp.data;
          console.log(resp);
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    makeDirty(row) {
      if (!row.rowDirty) {
        this.dirtyCount++;
        row.rowDirty = true;
        this.isDirty = true;
      }
    },
    rFlex(pt, documentId) {
      this.roleFlex.show = true;
      this.roleFlex.documentId = documentId;
      this.roleFlex.docPart = pt;
    },
    prepEditPartLookup(tmpl_part_id) {
      this.isLoading = true;
      axios
        .get("document/getTemplatePartValues/" + tmpl_part_id)
        .then((resp) => {
          this.textEdit.lookup = resp.data.Data;
          this.textEdit.show = true;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    saveTextEdit(newval) {
      this.saveRow(
        this.textEdit.row,
        newval.text,
        newval.notes,
        newval.subParts,
        newval.is_essential,
        newval.quality,
        this.textEdit.partType
      );
      this.textEdit.show = false;
    },
    deleteTextEdit() {
      this.deleteRow(
        this.textEdit.row,
        this.textEdit.partType,
        this.textEdit.parent
      );
      this.textEdit.show = false;
    },
    applyReadOnlyHighlights(text, tmpl_part_metadata) {
      if (this.document.doc_status === "APPROVED") {
        return text;
      } else {
        let status = utils.applyHighlights(
          text,
          this.textEdit.wordChecks.filter((w) =>
            w.tmpl_part_types.some(
              (tp) => tp.tp_id === tmpl_part_metadata.tmpl_part_id
            )
          ),
          true
        );
        return status.highlightedText;
      }
    },
    openCheckStatus() {
      this.showCheckStatus = true;
    },
    setCheckSummary() {
      this.checkSummary = utils.documentCheckSummary(
        this.document,
        this.textEdit.wordChecks,
        this.checkSummaryView
      );
    },
    allCheckSummaryPanels() {
      this.checkSummaryPanels = this.checkSummary.categories.map((c, i) => i);
    },
    closeCheckSummaryPanels() {
      this.checkSummaryPanels = [];
    },
    closeCheckStatus() {
      this.showCheckStatus = false;
    },
    openHeader() {
      this.showHeaderDetail = true;
    },
    documentHeaderClosed() {
      this.showHeaderDetail = false;
    },
    documentHeaderSaved(responseData) {
      this.setupDocument(responseData.Data.documents);
      this.setCheckSummary();

      this.setEditable();
      this.showHeaderDetail = false;
      this.$emit("documentHeaderSaved", this.document);
      this.response = responseData;
    },
    async closeExternalDocument() {
      
      this.inlineView = "";
      this.showInline = false;
      this.$emit("closeExternalDocument", this.document);
    },
    copyCheck() {
      let text = "";
      if (this.checkSummary) {
        if (this.checkSummary.errors.length) {
          text = `${this.checkSummary.errors.length} error${
            this.checkSummary.errors.length > 1 ? "s" : ""
          }`;
        }
        if (this.checkSummary.warnings.length) {
          if (text) text += " and ";
          text += `${this.checkSummary.warnings.length} warning${
            this.checkSummary.warnings.length > 1 ? "s" : ""
          }`;
        }
        if (text) {
          this.confirmCopy = `The document has ${text}. Are you sure you want to copy it?`;
          this.confirmCopyShow = true;
          return false;
        }
      }
      return true;
    },
    doCopy() {
      this.confirmCopyShow = false;
      this.$emit("copyDocument", this.document);
    },
    copyDocument() {
      if (this.copyCheck()) {
        this.doCopy();
      }
    },
    linkDocumentAction(docType, action) {
      this.copymenu = false;
      if (action) {
        switch (action) {
          case "copy":
          case "link":
            this.$emit("copyDocument", this.document, docType.tmpl_id);
            break;
          case "view":
            this.$emit("openDocument", docType);
            break;
        }
        this.$emit("openDocument", docType);
      } else {
        switch (docType.Action.toLowerCase()) {
          case "copy":
            this.$emit("copyDocument", this.document, docType.tmpl_id);
            break;
          case "view":
            this.$emit("openDocument", docType);
            break;
        }
      }
    },
    validateForCopy: function () {},
    changeOrder: function (e, parttype) {
      // let parttype = e.moved.element.type,
      let updatedPartType = parttype;
      // this.document.parttypes.find(
      //   ptt => ptt.type ===  pt.type || parttype
      // );
      let data = updatedPartType.parts.map((r, i) => {
        let ret = {};
        ret.sequence = i + 1;
        ret.type = parttype;
        ret.doc_part_id = r.doc_part_id;
        return ret;
      });
      let orig = this.item
        ? this.item.parttypes
            .find((pt) => pt.type === parttype)
            .parts.find((p) => p.doc_part_id === this.document.doc_part_id)
        : null;
      this.isLoading = true;
      axios
        .post("document/savedocpartsequence/", data)
        .then((resp) => {
          if (orig) {
            if (resp.data.Status === "OK" && resp.data.RowsUpdated) {
              orig.parts = this.document.parts;
            } else {
              this.document.parts = orig.parts;
            }
          }
          this.response = resp.data;
          //console.log(resp);
          this.isLoading = false;
        })
        .catch((err) => {
          this.document[parttype].parts = orig[parttype].parts;
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    generatePDF() {
      var doc = document.getElementById("pdfsection");
      doc.innerHTML = this.docToHTML("", true, false);
      let id = this.documentId;
      var w = doc.offsetWidth;
      var h = doc.offsetHeight;
      this.isLoading = true;
      html2canvas(doc, {
        dpi: 300, // Set to 300 DPI
        scale: 3, // Adjusts your resolution
      }).then((canvas) => {
        var img = canvas.toDataURL("image/jpeg", 1);
        var pdf = new jsPDF("p", "pt", [w, h]);
        pdf.addImage(img, "JPEG", 0, 0, w, h);
        pdf.save(id + ".pdf");
        this.isLoading = false;
        doc.innerHTML = "";
        doc.h;
        this.exportMenu = false; // close export menu
      });
    },
    newWorkingPattern(html, wordCount) {
      let newVal = utils.partToSubParts(html);
      let wpPartType = this.document.parttypes.find(
        (pt) => pt.type === "Working Pattern"
      );
      wpPartType.parts[0].subParts = newVal;
      wpPartType.parts[0].text = html;
      wpPartType.wordCount = wordCount;
    },
    highlightSection(issue) {
      this.unhighlightSection();
      issue.items.forEach((t) => {
        t.instances.forEach((i) => {
          i.partsAffected.forEach((pa) => {
            this.document.parttypes.forEach((pt) => {
              pt.parts.forEach((p) => {
                if (pa === p.doc_part_id) p.highlightSection = true;
                p.childParts.forEach((cp) => {
                  if (pa === cp.doc_part_id) cp.highlightSection = true;
                });
              });
            });
          });
        });
      });
    },
    unhighlightSection() {
      this.document.parttypes.forEach((pt) => {
        pt.parts.forEach((p) => {
          p.highlightSection = false;
          p.childParts.forEach((cp) => (cp.highlightSection = false));
        });
      });
    },
    scrollToSection(issue) {
      let options = {
        container: ".v-dialog--active.v-dialog--fullscreen", //this.$refs.doccontainer, //"#container",
        easing: "ease-in",
        offset: -60,
        force: true,
        cancelable: true,
        // onStart: function (element) {
        //   // scrolling started
        // },
        // onDone: function (element) {
        //   // scrolling is done
        // },
        // onCancel: function () {
        //   // scrolling has been interrupted
        // },
        x: false,
        y: true,
      };
      let next;
      let thisSet = [];
      let processing = true;
      while (processing) {
        issue.items.forEach((t) => {
          t.instances.forEach((i) => {
            i.partsAffected.forEach((pa) => {
              if (this.dpScrolled.indexOf(pa) >= 0) {
                thisSet.push(pa);
              } else if (!next) {
                next = pa;
                thisSet.push(pa);
              }
            });
          });
        });
        if (
          this.dpScrolled.length === thisSet.length &&
          thisSet.length > 0 &&
          this.dpScrolled[thisSet.length - 1] === thisSet[thisSet.length - 1]
        ) {
          this.dpScrolled.splice(0);
          thisSet.splice(0);
        } else {
          processing = false;
        }
      }
      this.dpScrolled = thisSet;
      ScrollTo.scrollTo("#dp" + next, 500, options);
    },
    sendToTaleo() {
      this.reqDialogue.show = true;
    },
    postToTaleo() {
      if (!this.reqDialogue.value) {
        alert("Requisition Number must be entered");
        return;
      }
      let mm = `<br><p><b>Build your career at Akamai</b></p><p>Our ability to shape digital life today relies on developing exceptional people like you. The kind that can turn impossible into possible. We’re doing everything we can to make Akamai a great place to work. A place where you can learn, grow and have a meaningful impact. </p>`;
      mm += `<br><p>With our company moving so fast, it’s important that you’re able to build new skills, explore new roles, and try out different opportunities. There are so many different ways to build your career at Akamai, and we want to support you as much as possible. We have all kinds of development opportunities available, from programs such as GROW and Mentoring, to internal events like the APEX Expo and tools such as Linkedin Learning, all to help you expand your knowledge and experience here.</p>`;
      mm += `<br><p><b>Learn more</b></p><p>Not sure if this job is the right match for you or want to learn more about the job before you apply? Schedule a 15-minute exploratory call with the Recruiter and they would be happy to share more details. Here is the contact info for the recruiter assigned to this position:</p><br>`;
      let data = {
        ats_reference: this.reqDialogue.value,
        htmlInt:
          this.docToHTML("internal", false, false, this.reqDialogue.USA) + mm,
        htmlExt: this.docToHTML("external", false, false, this.reqDialogue.USA),
        reference: this.document.system_number,
        title: this.document.parttypes.find((t) => t.tmpl_part_id === 6)
          .parts[0].text, // this.document.doc_name,
        USA: this.reqDialogue.USA,
      };

      axios
        .post("client/pingtaleo/", data)
        .then((resp) => {
          this.response = resp.data;
          this.isLoading = false;
          this.reqDialogue.show = false;
          this.reqDialogue.USA = false;
          this.reqDialogue.value = "";
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    docToClipboard(section) {
      let copyText = document.getElementById("htmlexport");
      copyText.value = this.docToHTML(section);
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand("copy");
    },
    docToHTML(section, forDocx, showNotes, USJob) {
      let html = "";
      let ul = "<ul>",
        ul_e = "</ul>",
        li = '<li class="lst">',
        li_e = "</li>",
        p_s = "<p>",
        p_e = "</p>",
        n_s = '<p style="color: gray;"><i>',
        n_e = "</i></p>";
      let overrides =
        this.document.exportOverrides && this.document.exportOverrides.length
          ? this.document.exportOverrides
          : null;
      this.document.parttypes.forEach((pt) => {
        let includePT = !section,
          useDefaultText = false,
          overrideText = "";
        if (section) {
          // all this just for taleo export
          let applicableSections = (
            pt.tmpl_part_metadata.html_export_section || ""
          ).split("|");
          if (applicableSections.indexOf(section) >= 0) {
            includePT = true;
          } else {
            let special =
              applicableSections.find((x) => x.startsWith(section)) || "";
            useDefaultText = special === section + "_default";
            let possOverride = overrides
              ? overrides.find((x) => x.tp_id === pt.tmpl_part_id)
              : false;
            let override =
              possOverride &&
              possOverride.html_export_section.indexOf(section) >= 0
                ? possOverride
                : false;
            if (override && USJob) {
              overrideText = override.default_text;
              includePT = true;
            } else if (special === section + "_usa") {
              // always export whether location is USA or not
              includePT = true;
            }
          }
        }
        if (includePT) {
          let def_s = p_s,
            def_e = p_e;
          switch (pt.tmpl_part_metadata.html_export_tag) {
            case "bold_centre_large":
              def_s = forDocx
                ? '<h2 style="text-align: center; margin: auto;">'
                : '<h2 align="center">';
              def_e = "</h2>";
              break;
            case "bold_centre":
              def_s = forDocx
                ? '<h3 style="text-align: center; margin: auto;">'
                : '<p align="center"><b>';
              def_e = forDocx ? "</h3>" : "</b></p>";
              break;
            case "bold_left":
              def_s = forDocx ? "<h4>" : "<p><b>";
              def_e = forDocx ? "</h4>" : "</b></p>";
              if (section === "internal") def_s = "<br>" + def_s;
              break;
            case "list":
              def_s = li;
              def_e = li_e;
              break;
          }
          let needsULEnd = false;
          pt.parts.forEach((p, pi) => {
            if (!pt.tmpl_part_metadata.uses_essential_flag || p.is_essential) {
              if (overrideText) {
                html += `${def_s}${overrideText}${def_e}`;
              } else if (useDefaultText) {
                html += `${def_s}${pt.tmpl_part_metadata.default_text}${def_e}`;
              } else if (p.subParts && p.subParts.length) {
                let tag,
                  endTag,
                  ulStarted = false;
                if (pt.tmpl_part_metadata.html_export_tag === "list") {
                  if (def_s === li && pi === 0) {
                    html += ul;
                    needsULEnd = true;
                  }
                  html += `${def_s}${p.subParts[0].text}${def_e}`;
                  if (def_s === li && pi === pt.parts.length - 1) {
                    (html += ul_e), (needsULEnd = false);
                  }
                } else {
                  p.subParts.forEach((sp, spi) => {
                    if (sp.type === "listitem") {
                      tag = li;
                      endTag = li_e;
                      if (!ulStarted) {
                        html += ul;
                        ulStarted = true;
                      }
                    } else {
                      tag = def_s;
                      endTag = def_e;
                      if (ulStarted) {
                        html += ul_e;
                        ulStarted = false;
                      }
                    }

                    html += `${tag}${sp.text}${endTag}`;
                    if (spi === p.subParts.length - 1 && ulStarted) {
                      html += ul_e;
                      ulStarted = false;
                    }
                  });
                }
              } else {
                if (def_s === li && pi === 0) html += ul;
                html += `${def_s}${p.text}${def_e}`;
                if (def_s === li && pi === pt.parts.length - 1) html += ul_e;
              }
              // add the export default text if it is not empty and the field is
              if (
                pt.tmpl_part_metadata.export_default_text &&
                p.subParts[0].text === ""
              ) {
                let def_blue = def_s.replaceAll(">", ' style="color: blue;">');
                html += `${def_blue}${pt.tmpl_part_metadata.export_default_text}${def_e}`;
              }
              if (p.childParts.length) {
                html += ul;
                html += p.childParts.reduce((p, c) => {
                  return p + `<li>${c.text}</li>`;
                }, "");
                html += ul_e;
              }
              if (showNotes && p.notes) {
                html += `${n_s}${p.notes}${n_e}`;
              }
            }
          });
          if (needsULEnd) html += ul_e;
        }
      });
      this.exportMenu = false; // close export menu
      if (forDocx) {
        return html
          .replace(/‘/g, "&lsquo;")
          .replace(/’/g, "&rsquo;")
          .replace(/“/g, "&ldquo;")
          .replace(/”/g, "&rdquo;")
          .replace(/£/g, "&pound;")
          .replace(/€/g, "&euro;")
          .replace(/©/g, "&copy;")
          .replace(/®/g, "&reg;");
      }
      else {
        return html;
      }
    },
    convertHtmlToRtf(html, fullDoc) {
      if (!(typeof html === "string" && html)) {
        return null;
      }

      var tmpRichText, hasHyperlinks;
      var richText = html;

      if (fullDoc) {
        // Making Job Title larger if full doc selected ...
        richText = richText.replace(
          /^<(?:p align="center"><b>)/gi,
          "\n{\\pard\\qc{\\b\\fs34{}"
        );
      }

      // Singleton tags
      richText = richText.replace(
        /<(?:hr)(?:\s+[^>]*)?\s*[\\/]?>/gi,
        "\n{\\pard \\brdrb \\brdrs \\brdrw10 \\brsp20 \\par}\n\r{\\pard\\par}"
      );
      richText = richText.replace(
        /<(?:br)(?:\s+[^>]*)?\s*[\\/]?>/gi,
        "\n{\\pard\\par\\sect}"
      );

      // Empty tags
      richText = richText.replace(
        /<(?:p|div|section|article)(?:\s+[^>]*)?\s*[\\/]>/gi,
        "{\\pard\\sect}"
      );
      richText = richText.replace(/<(?:[^>]+)\/>/g, "");

      // Hyperlinks
      richText = richText.replace(
        /<a(?:\s+[^>]*)?(?:\s+href=(["'])(?:javascript:void\(0?\);?|#|return false;?|void\(0?\);?|)\1)(?:\s+[^>]*)?>/gi,
        "{{{\n"
      );
      tmpRichText = richText;
      richText = richText.replace(
        /<a(?:\s+[^>]*)?(?:\s+href=(["'])(.+)\1)(?:\s+[^>]*)?>/gi,
        '{\\field{\\*\\fldinst{HYPERLINK\n "$2"\n}}{\\fldrslt{\\ul\\cf1\n'
      );
      hasHyperlinks = richText !== tmpRichText;
      richText = richText.replace(/<a(?:\s+[^>]*)?>/gi, "{{{\n");
      richText = richText.replace(/<\/a(?:\s+[^>]*)?>/gi, "\n}}}");

      // Start tags
      richText = richText.replace(
        /<(?:p align="center"><b>)/gi,
        "\n{\\pard\\qc{\\b\\fs25{}"
      );
      richText = richText.replace(
        /<(?:b|strong)(?:\s+[^>]*)?>/gi,
        "{\\b\\fs27{}"
      );
      richText = richText.replace(/<(?:i|em)(?:\s+[^>]*)?>/gi, "{\\i\n");
      richText = richText.replace(/<(?:u|ins)(?:\s+[^>]*)?>/gi, "{\\ul\n");
      richText = richText.replace(
        /<(?:strike|del)(?:\s+[^>]*)?>/gi,
        "{\\strike\n"
      );
      richText = richText.replace(/<sup(?:\s+[^>]*)?>/gi, "{\\super\n");
      richText = richText.replace(/<sub(?:\s+[^>]*)?>/gi, "{\\sub\n");
      richText = richText.replace(
        /<(?:p|div|section|article)(?:\s+[^>]*)?>/gi,
        "\n{\\pard{}"
      );
      richText = richText.replace(
        /<(?:li)(?:\s+[^>]*)?\s*[\\/]?>/gi,
        "\n{\\f2 {\\pntext \\bullet\\tab}{\\pn\\pnlvlblt\\pnstart1{\\pntxtb\\bullet}}{\\ltrch{}"
      );

      // End tags
      richText = richText.replace(
        /<\/(?:p|div|section|article)(?:\s+[^>]*)?>/gi,
        "\n\\line\\par}"
      );
      richText = richText.replace(/<\/(?:ul)(?:\s+[^>]*)?>/gi, "\\line{}");
      richText = richText.replace(
        /<\/(?:b|strong|i|em|u|ins|strike|del|sup|sub)(?:\s+[^>]*)?>/gi,
        "}"
      );
      richText = richText.replace(
        /<(?:\/li)(?:\s+[^>]*)?\s*[\\/]?>/gi,
        "}\\li720\\ri0\\sa0\\sb0\\jclisttab\\tx720\\fi-360\\ql\\par}"
      );

      // Strip any other remaining HTML tags [but leave their contents]
      richText = richText.replace(/<(?:[^>]+)>/g, "");

      richText = richText
          .replace(/‘/g, "\\'91")
          .replace(/’/g, "\\'92")
          .replace(/“/g, "\\'93")
          .replace(/”/g, "\\'94")
          .replace(/£/g, "\\'a3")
          .replace(/€/g, "\\'80")
          .replace(/©/g, "\\'a9")
          .replace(/®/g, "\\'ae");

      // Prefix and suffix the rich text with the necessary syntax
      richText =
        "{\\rtf1\\ansi\\deff0{\\fonttbl{\\f0 Open-Sans;}}" +
        (hasHyperlinks ? "{\\colortbl\n;\n\\red0\\green0\\blue255;\n}\n" : "") +
        richText +
        "\n}";

      return richText;
    },
    copyStringToClipboard(str) {
      // Create new element
      var el = document.createElement("textarea");
      // Set value (string to be copied)
      el.value = str;
      // Set non-editable to avoid focus and move outside of view
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      // Select text inside element
      el.select();
      el.setSelectionRange(0, 99999); /*For mobile devices*/
      // Copy text to clipboard
      document.execCommand("copy");
      // Remove temporary element
      document.body.removeChild(el);
    },
    generateRTF(section) {
      let rtfText = this.convertHtmlToRtf(this.docToHTML(section), true);
      utils.downloadFile(
        rtfText,
        this.document.system_number + " " + this.document.doc_type + ".rtf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      );
      this.exportMenu = false; // close export menu
    },
    generateDOCX(full) {
      let html = `<!DOCTYPE  html><html><body>
	  <style>
		p, h2, h3, h4 { font-family: calibri; }
		.lst { font-family: calibri; font-size: 12pt; }
	  </style>${this.docToHTML(null, true, full)}</body></html>`;
      html2docx(html, {
        orientation: "portrait",
        margins: { top: 820, bottom: 820 },
      }).then(data => {
        utils.downloadFile(
          data,
          this.document.system_number +
            (full ? " FULL" : " " + this.document.doc_type) +
            ".docx",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );
      });
      this.exportMenu = false; // close export menu
    },
    generateInterviewTemplate() {
      let n_s = '<p style="color: gray;"><i>',
        n_e = "</i></p>";
      let html = `<!DOCTYPE  html><html><body>
	  <style>
		.pagebreak { page-break-before: always !important; }
		.cell_p1 { padding-top: 30px; padding-bottom: 30px; padding-left: 15px; min-width: 30%; max-width: 30%; width: 30%;}
		.cell_p4 { padding-top: 30px; padding-bottom: 30px; padding-left: 15px; min-width: 70%; max-width: 70%; width: 70%; }
		.page_heading { font-weight: bold; font-size: 20pt; font-family: calibri; }
		.cell_heading { font-weight: bold; font-size: 13pt; }
		.ivSection { font-weight: bold; font-size: 13pt; font-family: calibri; min-height: 500px; }
		.cell_hint { font-style: italic; color: gray; }
		table, th, td { border: 1px solid black; border-collapse: collapse; }
		td { padding: 5px; }
	  </style>
	  <span class="page_heading">Interview Template - ${this.document.doc_name}</span>
	  <div><br/><br/><br/><br/></div>
	  <table style="width: 100%">
	  <tbody>
		<tr>
			<td class="cell_p1"><span class="cell_heading">Name of Candidate:</span></td>
			<td class="cell_p4">&nbsp;</td>
		</tr>
		<tr>
			<td class="cell_p1"><span class="cell_heading">Job Role:</span></td>
			<td class="cell_p4"><span class="cell_heading">${this.document.doc_name}</span></td>
		</tr>
		<tr>
			<td class="cell_p1"><span class="cell_heading">Interviewer(s):</span></td>
			<td class="cell_p4">&nbsp;</td>
		</tr>
		<tr>
			<td class="cell_p1"><span class="cell_heading">Date / Time of Interview:</span></td>
			<td class="cell_p4">&nbsp;</td>
		</tr>
	  </tbody>
	  </table>`;
      let reqSummary = `
	  	<p class="pagebreak"><span class="page_heading">Interview Template - ${this.document.doc_name}</span></p>
	  	<table style="width: 100%"><caption>Overall Summary</caption>
			<tr>
				<td colspan="8">&nbsp;</td>
				<td><span class="cell_heading">Rating</span></td>
			</tr>`;
      this.document.parttypes
        .find((pt) => pt.type === "Requirement")
        .parts.filter((p) => p.is_essential)
        .forEach((p) => {
          reqSummary += `
			<tr>
				<td colspan="8">${p.text}</td>
				<td>&nbsp;</td>
			</tr>`;
          html += `
	  <p class="pagebreak"><span class="page_heading">Interview Template - ${
      this.document.doc_name
    }</span></p>
	  <table>
		<tr>
			<td><span class="cell_heading">Requirement:</span><br/><span class="cell_hint">(Any skill/knowledge/experience that is essential for the role)</span></td>
			<td colspan="3"><span class="cell_heading">${p.text}</span></td>
		</tr>
		<tr>
			<td colspan="4"><span class="cell_heading">Indicators:</span> <span class="cell_hint">(what does good look like for this requirement)</span>
			<ul class="ivSection">
      ${p.childParts
        .filter((c) => c.dp_name === "Indicator")
        .reduce((p, c) => {
          return p + `<li>${c.text}</li>`;
        }, "")}
			</ul></td>
		</tr>
		<tr>
			<td colspan="4"><span class="cell_heading">Interview Questions:</span>
			<ul class="ivSection">
      ${p.childParts
        .filter((c) => c.dp_name === "Question")
        .reduce((p, c) => {
          return p + `<li>${c.text}</li>`;
        }, "")}
			</ul></td>
		</tr>
		<tr>
			<td colspan="4"><span class="cell_heading">Evidence:</span> <span class="cell_hint">(summarise evidence from your notes)</span><br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</td>
		</tr>
		<tr>
			<td colspan="4"><span class="cell_heading">Rating</span></td>
		</tr>
		<tr>
			<td style="width: 25%; text-align: center;">1</td>
			<td style="width: 25%; text-align: center;">2</td>
			<td style="width: 25%; text-align: center;">3</td>
			<td style="width: 25%; text-align: center;">4</td>
		</tr>
		<tr>
			<td style="width: 25%; text-align: center;">${n_s}No evidence (not competent or experienced)${n_e}</td>
			<td style="width: 25%; text-align: center;">${n_s}Some evidence (some competence or experience)${n_e}</td>
			<td style="width: 25%; text-align: center;">${n_s}Good evidence (good competence or experience)${n_e}</td>
			<td style="width: 25%; text-align: center;">${n_s}Excellent evidence (excellent competence or experience)${n_e}</td>
		</tr>
	  </table>`;
        });
      reqSummary += `
			<tr>
				<td colspan="8" style="text-align: right;">TOTAL</td>
				<td>&nbsp;</td>
			</tr>
			<tr>
				<td colspan="9" >Additional notes:<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</td>
			</tr>
			<tr>
				<td colspan="9" >Decision:<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</td>
			</tr>
			</table>`;
      html +=
        reqSummary +
        `
	  	<p class="pagebreak"><span class="page_heading">How to use this Interview Template</span></p>
		<table style="width: 100%">
	  <tbody>
		<tr>
			<td style="width: 34%;"><span class="cell_heading">Preparing for the Interview</span></td>
			<td style="width: 22%;"><span class="cell_heading">Conducting the Interview</span></td>
			<td style="width: 22%;"><span class="cell_heading">Scoring the Interview</span></td>
			<td style="width: 22%;"><span class="cell_heading">Avoiding Bias</span></td>
		</tr>
		<tr>
			<td style="vertical-align: top; font-size: 10pt; width: 34%;">
				1.	Decide on which of the essential requirements for the role you are going to assess in the interview<br/><br/>
				2.	Write interview questions for each requirement and add these to the interview template.  These should consist of an opening question and probing questions. <br/><br/>
				3.	Think about what good looks like for this requirement and add these to the interview template as indicators<br/>
				<br/>
				For example:<br/>
				<b>Requirement:</b> <br/>
				"Experience managing complex global projects"<br/>
				<br/>
				<b>Indicators:</b><br/>
				-	Has managed multiple, complex projects previously<br/>
				-	Can describe each stage of the project management lifecycle<br/>
				-	Demonstrates various methods to keep stakeholders updated<br/>
				<br/>
				<b>Opening question:</b> <br/>
				"Tell me about a time when you have managed a complex project with multiple stakeholders"<br/>
				<br/>
				<b>Probing questions:</b><br/>
				"What was your specific role on the project?"<br/>
				"How did you manage the complexity?"<br/>
				"How did you communicate with the stakeholders?"<br/>
				"What feedback did you receive?"<br/>
			</td>
			<td style="vertical-align: top; font-size: 10pt; width: 22%;">
				<b>At the start of the interview:</b>
				<ul>
					<li>Meet and greet the candidate and introduce those present</li>
					<li>Explain that the interview is a two -way exchange of information.</li>
					<li>Indicate how long the interview is likely to last</li>
					<li>Explain that the interview is structured around essential requirements for the job and that you will be looking for specific examples of what the candidate has done</li>
					<li>Explain that you will be taking notes</li>
				</ul>
				<b>During the interview:</b>
				<ul><li>Take notes on evidence relating to each requirement and question</li></ul>
				<b>At the end of the interview:</b>
				<ul><li>Give the candidate the opportunity to ask any questions and explain to them the next steps in the process</li></ul>
			</td>
			<td style="vertical-align: top; font-size: 10pt; width: 22%;">
				<ul>
					<li>As soon as possible after the interview, review your notes and confirm any evidence against each requirement</li>
					<li>Assign a rating to each requirement</li>
					<li>If more than one interviewer is present, each person should score the interview separately</li>
					<li>Use the ratings from the interview to decide whether the candidate should go forward to the next stage of the process</li>
					<li>Make sure that your notes explain the reason for your decision</li>
				</ul>
			</td>
			<td style="vertical-align: top; font-size: 10pt; width: 22%;">
				<ul>
					<li>Make sure you have an understanding of the essential requirements for the role and that you are basing your interview around these</li>
					<li>If more than one interviewer is present, each person should score the interview first before discussing to avoid priming / Groupthink</li>
					<li>Be aware of our unconscious tendency to favour people who remind us of ourselves (in-group bias)</li>
					<li>Try not to put too much weight on first impressions, whether these are negative or positive.  Make sure that evidence from the whole interview is taken into account</li>
					<li>Assessors allow the same time and stick to the script to avoid 'intuition' or 'gut' feel</li>
					<li>Don’t compare candidates to each other.  Make sure you are assessing each candidate fairly against the requirements for the job, not against each other</li>
				</ul>
			</td>
		</tr>
	  </tbody>
		</table>
	  </body></html>`;
      html = html.replace(/’/g, "'");
      html = html.replace(/•/g, "");
      
      html2docx(html, {
        orientation: "landscape",
        margins: { top: 520, bottom: 520, left: 500, right: 500 },
      }).then(data => {
        utils.downloadFile(
          data,
          this.document.system_number + " Interview Template.docx",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );
      });
      this.exportMenu = false; // close export menu
    },
    generateIntakeFlow() {
      // let n_s = '<p style="color: gray;"><i>',
      //   n_e = "</i></p>";
      let html = `
        <!DOCTYPE  html><html><body>
          <style>
            .pagebreak { page-break-before: always !important; }
            .cell_p0 { min-width: 15%; max-width: 15%; width: 15%;}
            .cell_p1 { padding: 5px; pmin-width: 20%; max-width: 20%; width: 20%;}
            .cell_p2 { padding: 5px; min-width: 25%; max-width: 25%; width: 25%;}
            .cell_p3 { padding: 5px; min-width: 30%; max-width: 30%; width: 30%;}
            .cell_p4 { padding: 5px; min-width: 50%; max-width: 50%; width: 50%; }
            .cell_across { padding: 0; min-width: 100%; max-width: 100%; width: 100%; }
            .page_heading { font-weight: bold; font-size: 14pt; text-decoration: underline; text-align: center;}
            .section_heading { padding-top: 8px; padding-bottom: 8px; padding-left: 15px; margin:0; font-weight: bold; text-align: center;}
            .cell_heading { padding:0; font-weight: bold; background-color: #DBE5F1 }
            .ivSection { font-weight: bold; font-family: calibri; min-height: 500px; }
            .cell_hint { font-style: italic; color: gray; }
            table, th, td { border: 1px solid black; border-collapse: collapse; }
            td { padding: 0 5px; }
            * { font-family: calibri; font-size: 9pt; }
          </style>
          <div class="page_heading">Launch Meeting Plan</div>
          <table style="width: 100%">
            <tr style="height: 14px">
              <td class="cell_across" colspan="4" style="background-color: #366091; color: white;">
                <div class="section_heading">POSITION INFORMATION</div>
              </td>
            </tr>
            <tr style="height:20px">
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Date of Call/Meeting:</td>
              <td class="cell_p2">&nbsp;</td>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Recruiter:</td>
              <td class="cell_p2">${this.$loginState.user.name}</td>
            </tr>
            <tr>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Position Title:</td>
              <td class="cell_p2">${this.document.doc_name}</td>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Requisition #:</td>
              <td class="cell_p2">&nbsp;</td>
            </tr>
            <tr>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Job Posting Title:</td>
              <td class="cell_p2">${
                this.document.parttypes.find(
                  (pt) =>
                    pt.type === "Advert Job Title" ||
                    pt.type === "Título de Trabajo del Anuncio" ||
                    pt.type === "Título de Trabajo"
                ).parts[0].text
              }</td>
              <td class="cell_p4 cell_heading" style="background-color: #DBE5F1" colspan="2">Is the Job title appropriate & relevant for attraction?</td>
            </tr>
            <tr>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Hiring Manager:</td>
              <td class="cell_p2">&nbsp;</td>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Business Group/Function:</td>
              <td class="cell_p2">&nbsp;</td>
            </tr>
            <tr>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">`;
      if (
        this.$loginState.user.client === "Akamai" ||
        this.$loginState.user.client === "staging"
      ) {
        html += `Mid-point budget:</td>
              <td class="cell_p2">&nbsp;<br></td>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Sales roles: % split, bonus % & type</td>
              <td class="cell_p2">&nbsp;<br></td>`;
      } else {
        html += `Salary:</td>
              <td class="cell_p2" colspan="3">&nbsp;<br></td>`;
      }
      html += `
            </tr>
            <tr style="height:50px">
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Relocations Considered?</td>
              <td class="cell_p2">&nbsp;<br></td>
              <td class="cell_p1 cell_heading" style="background-color: #DBE5F1">Expecting internal candidates?<br>From what teams?</td>
              <td class="cell_p2">&nbsp;<br></td>
            </tr>
            <tr style="height: 10px">
              <td class="cell_across" colspan="4" style="background-color: #366091; color: white;">
                <div class="section_heading">JOB USP</div>
              </td>
            </tr>
            <tr style="height:90px">
              <td colspan="4">${
                this.document.parttypes.find((pt) => pt.type === "Job USP")
                  .parts[0].text
              }</td>
            </tr>
            <tr style="height:60px">
              <td class="cell_p4 cell_heading" style="background-color: #DBE5F1" colspan="2">Additional unique selling points (to build on above to discuss with candidate) - why should anyone apply for the position?</td>
              <td colspan="2">&nbsp;</td>
            </tr>
        <tr style="height: 10px">
          <td class="cell_across" colspan="6" style="background-color: #366091; color: white;">
            <div class="section_heading">FURTHER NOTES/INFORMATION</div>
          </td>
        </tr>
        <tr style="height:80px">
          <td colspan="6">&nbsp;</td>
        </tr>
          </table>
          <p class="pagebreak">&nbsp;</p>
          <table style="width: 100%">
            <tr style="height: 14px">
              <td class="cell_across" colspan="10" style="background-color: #366091; color: white;">
                <div class="section_heading">RESPONSIBILITIES</div>
              </td>
            </tr>
            <tr>
              <td class="cell_p4 cell_heading" colspan="7" style="background-color: #DBE5F1">Responsibilities</td>
              <td class="cell_p4 cell_heading" colspan="3" style="background-color: #DBE5F1">Any more information to bring the role to life</td>
            </tr>`;
      let respSummary = "";
      let noResps = this.document.parttypes.find(
        (pt) => pt.type === "Responsibility"
      ).parts.length;
      this.document.parttypes
        .find((pt) => pt.type === "Responsibility")
        .parts.forEach((p) => {
          respSummary += `
            <tr>
              <td colspan="7">${p.text}</td>
            </tr>`;
        });
      html +=
        respSummary +
        `
              <tr style="height:60px">
                <td class="cell_p4 cell_heading" style="background-color: #DBE5F1" colspan="7">What are the key challenges someone may face in this role in the first 3-6 months?</td>
                <td colspan="3">&nbsp;</td>
              </tr>`;
      if (noResps < 6) {
        html += `
            <tr style="height: 10px">
              <td class="cell_across" colspan="10" style="background-color: #366091; color: white;">
                <div class="section_heading">FURTHER NOTES/INFORMATION</div>
              </td>
            </tr>
            <tr style="height:100px">
              <td colspan="10">&nbsp;</td>
            </tr>`;
      }
      html += `
          </tbody>
          </table>
          <p class="pagebreak">&nbsp;</p>
          <table style="width: 100%">
            <tr style="height: 14px">
              <td class="cell_across" colspan="6" style="background-color: #366091; color: white;">
                <div class="section_heading">ABOUT THE TEAM</div>
              </td>
            </tr>
            <tr style="height:70px">
              <td colspan="6">${
                this.document.parttypes.find(
                  (pt) => pt.type === "About the Team"
                ).parts[0].text
              }</td>
            </tr>
            <tr style="height:30px">
              <td class="cell_p4 cell_heading" style="background-color: #DBE5F1" colspan="3">Who are the key stakeholders / team / department this person will work with and in what capacity?</td>
              <td colspan="3">&nbsp;</td>
            </tr>
            <tr style="height:30px">
              <td class="cell_p4 cell_heading" style="background-color: #DBE5F1" colspan="3">Department/Team Structure</td>
              <td colspan="3">&nbsp;</td>
            </tr>
            <tr style="height: 10px">
              <td class="cell_across" colspan="6" style="background-color: #366091; color: white;">
                <div class="section_heading">POSITION REQUIREMENTS</div>
              </td>
            </tr>
            <tr>
              <td class="cell_p4 cell_heading" colspan="3" style="background-color: #DBE5F1">Essential Requirements</td>
              <td class="cell_p4 cell_heading" colspan="3" style="background-color: #DBE5F1">Telephone/Pre-Screening Criteria / Questions</td>
            </tr>`;
      let reqSummary = "";
      let noReqs = this.document.parttypes.find(
        (pt) => pt.type === "Requirement"
      ).parts.length;
      this.document.parttypes
        .find((pt) => pt.type === "Requirement")
        .parts.filter((p) => p.is_essential)
        .forEach((p) => {
          reqSummary += `
        <tr>
          <td colspan="3">${p.text}</td>
          <td colspan="3">&nbsp;</td>
        </tr>`;
        });
      html += reqSummary;
      if (noReqs < 6) {
        html += `
            <tr style="height: 10px">
              <td class="cell_across" colspan="10" style="background-color: #366091; color: white;">
                <div class="section_heading">FURTHER NOTES/INFORMATION</div>
              </td>
            </tr>
            <tr style="height:150px">
              <td colspan="10">&nbsp;</td>
            </tr>`;
      }
      html += `
          </table>
          <p class="pagebreak">&nbsp;</p>
          <table style="width: 100%">
        <tr style="height: 10px">
          <td class="cell_across" colspan="2" style="background-color: #366091; color: white;">
            <div class="section_heading">INSIGHT AND MARKET INTELLIGENCE</div>
          </td>
        </tr>
        <tr style="height:60px">
          <td class="cell_p4 cell_heading" style="background-color: #DBE5F1">
            Are there alternative job titles / common in competitor market? TA to make suggestions
          </td>
          <td>&nbsp;</td>
        </tr>
        <tr style="height:50px">
          <td class="cell_p4 cell_heading" style="background-color: #DBE5F1">
            Any movements in the market that you are aware of? Any opportunity? 
          </td>
          <td>&nbsp;</td>
        </tr>
        <tr style="height: 10px">
          <td class="cell_across" colspan="2" style="background-color: #366091; color: white;">
            <div class="section_heading">SOURCING & ATTRACTION STRATEGY</div>
          </td>
        </tr>
        <tr style="height:70px">
          <td class="cell_p4 cell_heading" style="background-color: #DBE5F1">Please provide any details of target competitors/ local communities/groups</td>
          <td>&nbsp;</td>
        </tr>
        <tr style="height:70px">
          <td class="cell_p4 cell_heading" style="background-color: #DBE5F1">Have you asked for referrals from relevant team/networks? Discuss LinkedIn, sharing posts etc.</td>
          <td>&nbsp;</td>
        </tr>
        <tr style="height: 10px">
          <td class="cell_across" colspan="2" style="background-color: #366091; color: white;">
            <div class="section_heading">ANY OTHER COMMENTS/NOTES</div>
          </td>
        </tr>
        <tr style="height:150px">
          <td colspan="2">&nbsp;</td>
        </tr>
          </table>
          <p class="pagebreak">&nbsp;</p>
          <table style="width: 100%">
        <tr style="height: 10px">
          <td class="cell_across" colspan="2" style="background-color: #366091; color: white;">
            <div class="section_heading">INTERVIEW & ASSESSMENT</div>
          </td>
        </tr>
        <tr style="height:150px">
          <td class="cell_p4 cell_heading" style="background-color: #DBE5F1">
          How many interviews will there be and what format will these be in (phone, face-to-face, presentation)?<br>
          How long will each interview last?<br>
          Have you already considered who you would like in the interview process and what’s the diversity of the panel?<br>
          Do they know they will be involved?<br>
        `;
      if (
        this.$loginState.user.client === "Akamai" ||
        this.$loginState.user.client === "staging"
      ) {
        html += `<b>If appropriate</b> - please discuss if HackerRank should support this recruitment (this link should be sent as pre work)
                  https://docs.google.com/presentation/d/15LPYM5ZelFaN1DV1JXZziyD62iW6VENdkBXNRIfL6lc/edit?usp=sharing`;
      }
      html += `</td>
          <td>&nbsp;</td>
        </tr>
        <tr style="height: 10px">
          <td class="cell_across" colspan="2" style="background-color: #366091; color: white;">
            <div class="section_heading">ANY OTHER COMMENTS/NOTES</div>
          </td>
        </tr>
        <tr style="height:200px">
          <td colspan="2">&nbsp;</td>
        </tr>
      </body></html>`;
      html = html.replace(/’/g, "'");
      html = html.replace(/•/g, "");

      html2docx(html, {
        orientation: "landscape",
        margins: { top: 500, bottom: 500, left: 500, right: 500 },
      }).then(data => {
        utils.downloadFile(
          data,
          this.document.system_number + " Intake Flow.docx",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );
      });
      this.exportMenu = false; // close export menu
    },
    saveDocHeader(status) {
      this.isLoading = true;

      this.document.doc_status = status;
      let data = {
        system_number: this.document.system_number,
        doc_id: this.document.doc_id,
        doc_status: this.document.doc_status,
        doc_status_text: this.statuses.find((x) => x.status === status).text,
        recruiter: this.document.recruiter,
        contact: this.document.contact,
        approval_requested_date: this.document.approval_requested_date,
        start_date: this.document.start_date,
        quality: this.document.quality,
        hierarchies: this.document.hierarchies,
      };

      axios
        .post("document/saveDocumentHeader/", data)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            this.$emit("saved", resp.data);
          } else {
            alert(resp.data.Message);
          }
          this.response = resp.data;
          this.isLoading = false;
          this.show = false;
          this.document = null;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.dragHandle {
  color: rgba(56, 106, 163, 0.801) !important;
  cursor: grab;
  margin-left: -40px;
  /* margin-left: 30%; */
}
.status-chip {
  font-size: 0.7rem;
  margin-left: -8px;
  height: 25px;
}
.drag-handle,
.number-part {
  max-width: 20px;
  padding: 6px 0;
}
.data-content {
  margin-top: -5px;
  padding-top: 0;
}
.data-content-2 {
  margin-top: -7px;
  min-height: auto !important;
  max-height: auto;
  padding-bottom: 0;
}
.data-label {
  font-size: 0.6rem;
  padding: 0 5px 0 16px;
  color: darkgray;
}
.data-value {
  font-size: 0.9rem;
}
.data-value-2 {
  font-size: 0.8rem;
  font-style: italic;
  padding-bottom: 10px;
}
.editIcon {
  position: relative;
  left: 870px;
  bottom: 14px;
  font-size: 1.1rem;
  color: lightgrey;
}
.editIcon2 {
  position: relative;
  left: 824px;
  bottom: 18px;
  font-size: 1.1rem;
  color: lightgrey;
}
.addIcon {
  position: relative;
  left: 30px;
  top: 15px;
  font-size: 1.3rem;
  color: lightgray !important;
}
.workflowIcon {
  position: relative;
  left: -68px;
  bottom: 74px;
  font-size: 1.7rem;
  color: lightgrey;
}
.workflowIcon:hover {
  color: grey;
  text-shadow: 3px 3px 2px #9ecaed;
  cursor: pointer;
}
.notesIcon {
  /* position: relative; */
  left: 111.5%;
  z-index: 202;
  bottom: 18px;
  font-size: 1.1rem !important;
  color: rgba(56, 106, 163, 0.801) !important;
}
.notesIcon2 {
  /* position: relative; */
  z-index: 202;
  left: 121%;
  bottom: 18px;
  font-size: 1.1rem !important;
  color: rgba(56, 106, 163, 0.801) !important;
}
.notesIcon3 {
  /* position: relative; */
  z-index: 202;
  left: 136%;
  bottom: 18px;
  font-size: 1.1rem !important;
  color: rgba(56, 106, 163, 0.801) !important;
}
.pdfIcon {
  position: relative;
  left: 55px;
  top: 11px;
  height: 25px;
}
.addIcon:hover {
  color: black !important;
  box-shadow: none !important;
  border: none !important;
}
.notesIcon:hover,
.notesIcon2:hover,
.notesIcon3:hover {
  color: black !important;
}
/* .errorComment {
  font-style: italic;
  font-size: 0.75rem;
  position: relative;
  left: 169px;
  min-width: 150px;
}
.errorComment2 {
  font-style: italic;
  font-size: 0.75rem;
  position: relative;
  left: 122px;
  min-width: 105px;
} */
.CallToAction,
.LlamadaAcción {
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 1rem;
  color: rgb(73, 80, 87);
}
.AdvertJobTitle,
.TítulodeTrabajo,
.JobTitle {
  display: flex;
  justify-content: center;
  font-size: 1.8rem;
  margin-bottom: 5px;
  color: rgb(73, 80, 87);
}
.DocumentHdr {
  display: flex;
  justify-content: center;
  font-style: italic;
  font-size: 1.5rem;
  color: #9e9e9e;
  max-height: 5px;
}
.ContentTitle {
  display: flex;
  justify-content: center;
  font-size: 1.2rem;
  margin-bottom: -20px;
  color: rgb(0, 0, 0);
}
.GutterLabel {
  color: #ce8705ba;
  padding-left: 5px;
  padding-right: 5px;
}
.AboutTeamHdr,
.JobUSPHdr,
.JobPurposeHdr,
.ReqHdr,
.RespHdr,
.FlexibleWork,
.WithUsHdr,
.ForYouHdr,
.AboutUsHdr,
.JoinUsHdr,
.ClosingCopyHdr,
.AboutYouHdr,
.PreparingHdr,
.ConductingHdr,
.ScoringHdr,
.AvoidingHdr {
  font-weight: 700;
  font-size: 1.1rem;
  padding-bottom: 0;
  color: rgb(73, 80, 87);
}
.WorkingPattern {
  line-height: 18px;
}
.Responsibility,
.Requirement,
.Activity,
.Indicator {
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
}
.AdvertJobTitleGutter,
.TítulodeTrabajoGutter,
.JobTitleGutter,
.CallToActionGutter,
.LlamadaAcciónGutter,
.AbouttheTeamGutter,
.JobUSPGutter,
.JobPurposeGutter,
.JobPurposeHdrGutter,
.ResponsibilityGutter,
.RequirementGutter,
.ActivityGutter,
.IndicatorGutter,
.FlexibleWorkGutter,
.WorkingPatternGutter,
.AboutYouGutter {
  color: #ce8705ba;
  width: 0px;
}
.JobUSPHdrRow,
.JobPurposeHdrRow,
.RespIntroRow,
.ReqIntroRow,
.ResponsibilityRow,
.RequirementRow,
.ActivityRow,
.IndicatorRow,
.FlexibleWorkRow,
.FlexIntroRow,
.WorkingPatternRow,
.WithUsRow,
.ForYouRow,
.AboutUsRow,
.JoinUsRow,
.ListItemRow,
.ClosingCopyRow,
.ReqHdrRow,
.RespHdrRow,
.AbouttheTeamRow,
.JobUSPRow,
.RequirementIntroRow,
.AboutYouRow {
  margin-top: -10px;
}
.CallToActionRow,
.LlamadaAcciónRow {
  margin-top: -15px;
}
.AdvertJobTitleRow,
.TítulodeTrabajoRow,
.JobTitleRow {
  margin-top: 10px;
}
.JobUSPHdrGutter,
.JobPurposeHdrGutter,
.RespIntroGutter,
.ReqIntroGutter,
.AboutTeamHdrGutter,
.ReqHdrGutter,
.RespHdrGutter,
.FlexIntroGutter,
.WithUsHdrGutter,
.ForYouHdrGutter,
.AboutUsHdrGutter,
.JoinUsHdrGutter,
.WithUsGutter,
.JoinUsGutter,
.AboutUsGutter,
.ForYouGutter,
.ClosingCopyHdrGutter,
.ClosingCopyGutter,
.RequirementIntroGutter,
.ContentTitleGutter,
.AboutYouHdr,
.DocumentHdrGutter,
.InterviewHdrGutter,
.PreparingHdrGutter,
.PreparingTextGutter {
  display: none !important;
}
.JobUSPHdrError,
.JobPurposeHdrError,
.RespIntroError,
.ReqIntroError,
.AboutTeamHdrError,
.ReqHdrError,
.RespHdrError,
.FlexIntroError,
.WorkingPatternError,
.AboutUsError,
.FlexibleWorkError,
.WithUsHdrError,
.WithUsError,
.ForYouHdrError,
.ForYouError,
.AboutUsHdrError,
.JoinUsHdrError,
.ClosingCopyHdrError,
.ClosingCopyError,
.RequirementIntroError,
.JobTitleError,
.ContentTitleError,
.AboutYouHdrError,
.DocumentHdrError,
.PreparingListError,
.PreparingTextError {
  display: none !important;
}
.headerCell {
  padding: 10px 10px 10px 0;
}
.headerCellSmall {
  padding: 0 10px;
  font-size: 0.75rem;
  color: #946206da;
}
@media print {
  .AdvertJobTitle,
  .TítulodeTrabajo {
    font-size: 1.5rem !important;
  }
  .CallToAction,
  .LlamadaAcción {
    margin-top: -25px;
    font-size: 0.8rem !important;
  }
  .JobUSPHdrRow,
  .RespIntroRow,
  .WithUsRow,
  .WithUsHdr,
  .FlexIntro,
  .WorkingPattern,
  .ForYouHdr,
  .ForYouRow,
  .AboutUsHdr,
  .AboutUsRow {
    margin-top: -30px;
  }
  .list-group {
    margin-top: -30px;
  }
}
.editArea,
.editAreaReadOnly {
  margin-left: 50px;
  white-space: pre-wrap;
  border: solid white 1px;
}
.editArea:hover {
  outline: none;
  box-shadow: 0 0 10px #9ecaed;
  border: solid #9ecaed 1px;
  cursor: pointer;
  border-radius: 5px;
}
.editAreaBlank {
  outline: none;
  color: #ed8a8a !important;
  box-shadow: 0 0 5px #ed8a8a30;
  border: solid #ed8a8a30 1px;
  cursor: pointer;
  border-radius: 5px;
  font-style: italic;
  font-weight: 300 !important;
  margin-left: 50px;
}
.editAreaListBlank {
  display: list-item;
  outline: none;
  color: #ed8a8a !important;
  box-shadow: 0 0 5px #ed8a8a30;
  border: solid #ed8a8a30 1px;
  cursor: pointer;
  border-radius: 5px;
  font-style: italic;
  font-weight: 300 !important;
}
.editAreaBlank .CallToAction,
.editAreaBlank .LlamadaAcción,
.editAreaBlank .AboutTeamHdr {
  outline: none;
  color: #ed8a8a !important;
  font-style: italic;
  font-weight: 300 !important;
}
.parentList {
  border: solid 1px lightgrey !important;
  border-radius: 4px !important;
  margin-top: 5px !important;
  margin-right: 3px !important;
}
.editAreaList,
.editAreaListReadOnly {
  display: list-item;
  margin-top: -4px;
  border: solid white 1px;
}
.editAreaList:hover {
  outline: none;
  box-shadow: 0 0 10px #9ecaed;
  border: solid #9ecaed 1px;
  cursor: pointer;
  border-radius: 5px;
}
.editAreaBlank:hover,
.editAreaListBlank:hover {
  outline: none;
  box-shadow: 0 0 10px #9ecaed;
  border: solid #9ecaed 1px;
  cursor: pointer;
  border-radius: 5px;
}
.v-input--selection-controls {
  margin-top: 3px;
}
label,
.v-label,
.v-input--selection-controls .v-input__slot > .v-label {
  font-size: 10px;
}
.v-messages {
  max-height: 1px;
}
.desirableText {
  color: #aaa;
  font-weight: 300;
  font-style: italic;
}
.essential {
  position: relative;
  left: 65px;
  top: -5px;
  max-height: 20px;
  font-style: italic;
}
.wayBack {
  height: 0;
  position: relative !important;
  top: 16px;
  left: 1000px;
  z-index: 200;
  color: lightgray !important;
}
.wayBackHidden {
  display: none;
}
@keyframes hideshow {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}
.wayBackDisplayed {
  position: relative;
  right: -49px;
  top: -8px;
  animation: hideshow 2s ease;
  margin-bottom: -12px;
}
.v-list-item__action {
  margin: 1px 0;
}
.subPartGutter {
  position: absolute;
  left: -80px;
  color: #ce8705ba;
}
.subPartSpan {
  position: absolute;
  left: 73px;
}
.subPartText {
  margin-left: -70px;
}
div .subPartRow:not(first-child) {
  margin-left: -4px;
}
</style>
<style>
label[for="linkedDoc"] {
  font-size: 15px;
}
.desirableText {
  color: #aaa;
  font-weight: 300;
  font-style: italic;
}
.desirableBox div div div i {
  color: #f55 !important;
}
.essential label {
  color: rgba(128, 128, 128, 0.637) !important;
  font-size: 12px;
  margin-left: -7px;
}
#sd-menu {
  top: 0px !important;
  left: 29px;
}
#sd-menu button {
  top: -1px;
  width: 30px;
  height: 30px;
}
#sd-sub-menu {
  margin-top: -25px;
  width: 24px !important;
  height: 24px !important;
  margin-bottom: 0px;
  background-color: #ffffff5e;
}
#sd-menu button i {
  font-size: 18px;
}
#sd-sub-menu-2 span i {
  font-size: 14px;
  left: 79px;
}
#sd-sub-menu-2 {
  margin-top: -25px;
  width: 24px !important;
  height: 24px !important;
  margin-bottom: 0px;
  background-color: #ffffff5e;
}
#sd-sub-menu-2 span i {
  font-size: 14px;
  left: 93px;
}
#sd-pdf {
  left: 51px !important;
  top: -1px;
  font-size: 17px !important;
}
#sd-word {
  left: 57px !important;
  top: -1px;
  font-size: 17px !important;
}
#sd-word-full {
  left: 78px !important;
  top: -1px;
  font-size: 17px !important;
}
.speed-dial__list button {
  width: 22px !important;
  height: 22px !important;
}
.speed-dial__list button div i {
  font-size: 10px;
}
.speed-dial__list button div span {
  opacity: 1 !important;
  color: black;
  transform: none !important;
  position: relative !important;
  left: 97px !important;
  text-align: left !important;
}
#pdfsection > p {
  padding-top: 15px;
  margin-bottom: 0px;
}
#pdfsection li {
  padding-top: 5px;
  margin-left: 10px;
  list-style-position: outside;
  padding-left: 10px;
}
#pdfsection > h2,
#pdfsection > h3,
#pdfsection > h4 {
  padding-top: 25px;
}
button.v-expansion-panel-header {
  padding: 1px;
}
span.v-expansion-panel-header {
  font-size: 14px;
}
@keyframes slidein {
  0% {
    transform: translate(0, -400px);
  }
  100% {
    transform: translate(0, 100px);
  }
}
.highlightSection {
  /* font-weight: 900; */
  background-color: lightgray;
  border: solid grey 2px;
}
li.highlightSection {
  border: none;
}
button.v-expansion-panel-header {
  min-height: 36px;
}
button > .v-expansion-panel-header--active,
button > .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 36px;
}
div.v-expansion-panel-content__wrap {
  padding: 0 14px 6px;
}
button.v-expansion-panel--active > .v-expansion-panel-header {
  max-height: 48px;
}
.scoreCard {
  border-radius: 25px !important;
  box-shadow: rgb(255, 255, 255) -2px -2px 4px 0px,
    rgba(0, 0, 0, 0.25) 8px 8px 8px 0px !important;
  display: block;
  flex: 1 1 0%;
  background-color: #ffffff26 !important;
  min-height: 500px;
  /* max-width: 350px; */
  margin-bottom: 25px;
  overflow: hidden;
  padding: 20px;
  z-index: 200;
  border: solid 2px #ffffffa8 !important;
}
.scoreTitle {
  font-size: 18px !important;
  margin-top: -14px !important;
  color: rgb(71, 71, 71) !important;
  padding: 0 !important;
}
.sectionScore {
  background: #f2f3f7;
  color: #222;
  transition: all 100ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: -2px -2px 2px rgba(255, 255, 255, 0.9),
    2px 2px 2px rgba(245, 245, 245, 0.9), 1px 1px 3px rgba(0, 0, 0, 0.07) !important;
}
.sectionScore:first-child {
  background: #f2f3f7;
  color: #222;
  transition: all 100ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: -2px -2px 2px rgba(245, 245, 245, 0.9),
    2px 2px 2px rgba(245, 245, 245, 0.9), 1px 1px 3px rgba(0, 0, 0, 0.07) !important;
}
.sectionText {
  font-size: 14px;
  padding: 11px;
}
.sectionItem {
  border: solid 1px white;
  padding: 0px 1px;
}
.sectionItem:hover {
  border: solid 1px rgb(187, 186, 186);
  cursor: grabbing;
}
.b-btn .sectionItem {
  padding: 0px 1px;
}
button.v-btn:not(.v-btn--round).v-size--x-small {
  padding: 0px 1px;
  min-width: 26px;
}
</style>